import { useEffect, useState } from "react";

const useAlertIconVisible = (pesquisa, lastSearchStr) => {
  const [showAlertIcon, setShowAlertIcon] = useState(false);

  //  SE DATA ULTIMA ATUALIZAÇÃO < HOJE
  useEffect(() => {
    const searchDateOlderThanToday = () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const lastSearchArray = lastSearchStr?.split("-");

      if (lastSearchArray?.length == 3) {
        const lastSearchDay = parseInt(lastSearchArray[2]);
        const lastSearchMonth = parseInt(lastSearchArray[1]) - 1;
        const lastSearchYear = parseInt(lastSearchArray[0]);
        const lastSearchDate = new Date(lastSearchYear, lastSearchMonth, lastSearchDay);

        if (lastSearchDate >= today) return false;
      }

      // Verificação de segurança para pesquisa e ultimaAtualizacao
      if (!pesquisa?.ultimaAtualizacao) {
        return false;
      }

      const dateArray = pesquisa.ultimaAtualizacao.split("/");

      // Verificação de segurança para dateArray
      if (!dateArray || dateArray.length < 3) {
        return false;
      }

      const dia = parseInt(dateArray[0]);
      const mes = parseInt(dateArray[1]) - 1;
      const ano = parseInt(dateArray[2]);
      const lastUpdateDate = new Date(ano, mes, dia);

      return lastUpdateDate < today;
    };

    const shouldBeVisible = searchDateOlderThanToday();

    setShowAlertIcon(shouldBeVisible);
  }, [pesquisa?.ultimaAtualizacao, lastSearchStr]);

  return {
    showAlertIcon,
    setShowAlertIcon,
  };
};

export default useAlertIconVisible;
